<template>
    <b-form-group label="" v-slot="{ ariaDescribedby }">
        <b-form-radio-group id="radio-group-2" v-model="selectedRange" :aria-describedby="ariaDescribedby"
            name="DateRangeSelector" class="d-flex justify-content-lg-start justify-content-center">
            <div class="form-check ps-sm-2 me-2">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="DateRangeSelector" v-model="selectedRange"
                        id="optionsRadios1" :value="1" />
                    {{ $translate('yesterday') }}
                    <i class="input-helper"></i>
                </label>
            </div>
            <div class="form-check ps-sm-2 me-2">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="DateRangeSelector" id="optionsRadios"
                        v-model="selectedRange" :value="0" />
                    {{ $translate('today') }}
                    <i class="input-helper"></i>
                </label>
            </div>


            <div class="form-check ps-sm-2 me-2">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="DateRangeSelector" id="optionsRadios2"
                        v-model="selectedRange" :value="3" />
                    {{ $translate('tomorrow') }}
                    <i class="input-helper"></i>
                </label>
            </div>
            <div class="form-check ps-sm-2 me-2">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="DateRangeSelector" id="optionsRadios3"
                        v-model="selectedRange" :value="4" />
                    {{ $translate('last_week') }}
                    <i class="input-helper"></i>
                </label>
            </div>
            <div class="form-check ps-sm-2 me-2">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" name="DateRangeSelector" id="optionsRadios4"
                        v-model="selectedRange" :value="5" />
                    {{ $translate('this_month') }}
                    <i class="input-helper"></i>
                </label>
            </div>

            <div class="form-check ps-sm-2">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" v-model="selectedRange" name="DateRangeSelector"
                        id="optionsRadios5" :value="2" />
                    {{ $translate('custom') }}
                    <i class="input-helper"></i>
                </label>
            </div>
        </b-form-radio-group>
    </b-form-group>
</template>
<script>
export default {
    data() {
        return {
            selectedRange: 2,
        }
    },
    props: ['value'],
    watch: {
        value: function (val) {
            this.selectedRange = val
        },
        selectedRange: function (val) {
            this.$emit('input', val)
        },
    },
    mounted() {
        this.selectedRange = this.value
    },
}
</script>
